import React from 'react';
import { CustomerSearch } from '@container/customer';
import {
  HomeMainNotice,
  HomeMainAppList,
  HomeMainArchive,
  HomeMainSchedule,
} from '@container/home';

const HomeMainTablet = ({ menuInfo }) => {
  // 청약진행현황: SFA_T_10401000
  // 고객검색: SFA_T_10103000
  // 공지사항: SFA_T_10600000
  // 자료실: SFA_T_10500000
  // 일정표: SFA_T_10702000

  return menuInfo ? (
    <>
      {(menuInfo?.SFA_T_10401000 || menuInfo?.SFA_T_10103000) && (
        <div className="sec-box justify-start">
          {/* 청약 목록 현황 */}
          {menuInfo?.SFA_T_10401000 && <HomeMainAppList />}

          {/* 고객 검색 */}
          {menuInfo?.SFA_T_10103000 && <CustomerSearch />}
        </div>
      )}

      {/* 일정표가 있을 때와 없을 때의 레이아웃 다르게 표시 */}
      {menuInfo?.SFA_T_10702000 ? (
        <div className="sec-box justify-start">
          <div className="half">
            {/* 공지사항 */}
            {menuInfo?.SFA_T_10600000 && <HomeMainNotice />}

            {/* 자료실 */}
            {menuInfo?.SFA_T_10500000 && <HomeMainArchive />}
          </div>

          {/* 일정표 */}
          <HomeMainSchedule />
        </div>
      ) : (
        <div className="sec-box justify-start">
          {menuInfo?.SFA_T_10600000 && (
            <div className="half">
              {/* 공지사항 */}
              <HomeMainNotice />
            </div>
          )}

          {menuInfo?.SFA_T_10500000 && (
            <div className="half">
              {/* 자료실 */}
              <HomeMainArchive />
            </div>
          )}
        </div>
      )}
    </>
  ) : (
    <>볼 수 있는 메인 컨텐츠가 없습니다.</>
  );
};

HomeMainTablet.propTypes = {
  menuInfo: $propTypes.object,
};

export default HomeMainTablet;
